import React from 'react';
import moment from 'moment';
import dig from 'object-dig';
import clsx from 'clsx';

import AlarmOnIcon from '@material-ui/icons/AlarmOn';
import CheckIcon from '@material-ui/icons/Check';
import DoneAllIcon from '@material-ui/icons/DoneAll';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';

import toInt from '~/utils/Number/toInt';
import { URL } from '~/config/uri';

const useStyles = makeStyles((theme) => ({
  text: {
    backgroundColor: theme.palette.primary.main,
    backgroundSize: 'auto',
    color: theme.palette.primary.contrastText,
    borderRadius: '8px',
    padding: '5px',
    display: 'inline-flex',
  },
  text2: {
    backgroundColor: '#ddd',
    backgroundSize: 'auto',
    color: theme.palette.grey.main,
    borderRadius: '8px',
    padding: '5px',
    display: 'inline-flex',
  },
}));

function ChannelData({ messages, user_id }) {
  const classes = useStyles();

  return (
    <>
      {messages.map((row) => {
        return (
          <ListItem key={row.id} alignItems="flex-start">
            <Grid container>
              <Grid item xs={1} style={{ marginRight: -20 }}>
                {row.user_from_id === toInt(user_id) && (
                  <ListItemAvatar
                    align={
                      row.user_from_id === toInt(user_id) ? 'left' : 'right'
                    }
                  >
                    <Avatar
                      src={`${URL}/public/user_face/${dig(
                        row,
                        'user_from_uuid'
                      )}.jpg?size=140`}
                    />
                  </ListItemAvatar>
                )}
              </Grid>
              <Grid item xs={10}>
                <ListItemText
                  align={row.user_from_id === toInt(user_id) ? 'left' : 'right'}
                  primary={
                    <>
                      <Typography
                        variant="body1"
                        component="span"
                        className={clsx(
                          row.user_from_id === toInt(user_id)
                            ? classes.text
                            : classes.text2
                        )}
                      >
                        {row.message}
                      </Typography>
                    </>
                  }
                  secondary={
                    <>
                      {moment(row.created_at).format('DD/MM/YYYY HH:mm:ss')}
                      {row.read_at && <DoneAllIcon />}
                      {!row.read_at && row.receive_at && <CheckIcon />}
                      {!row.read_at && !row.receive_at && <AlarmOnIcon />}
                    </>
                  }
                />
              </Grid>
              <Grid item xs={1} style={{ marginLeft: -20 }}>
                {row.user_from_id !== toInt(user_id) && (
                  <ListItemAvatar
                    align={
                      row.user_from_id === toInt(user_id) ? 'left' : 'right'
                    }
                  >
                    <Avatar
                      src={`${URL}/public/user_face/${dig(
                        row,
                        'user_from_uuid'
                      )}.jpg?size=140`}
                    />
                  </ListItemAvatar>
                )}
              </Grid>
            </Grid>
          </ListItem>
        );
      })}
    </>
  );
}

export default ChannelData;
